module.exports = __webpack_public_path__ + "img/mac-error1.0577a57b.svg";